export default __webpack_public_path__ + "static/media/arrowLeft.f1b3b6c2.svg";